/**
 * Escapes the five HTML special characters so that arbitrary text can be placed into content
 * that a component renders as HTML (for example the Syncfusion toast body).
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/** Joins plain-text lines into HTML, one line per `<br/>`, with every line escaped. */
export function linesToHtml(lines: string[]): string {
  return lines.map(escapeHtml).join('<br/>');
}
